var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-card-visa"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-visa",
    clipPath: "url(#clip-card-visa)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa_credit_card",
    "data-name": "Visa credit card",
    transform: "translate(-0.644 -11.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33620",
    "data-name": "Path 33620",
    d: "M6.56,27.1l-.8-3.859a.945.945,0,0,0-1.039-.709H1.028L1,22.72A7.545,7.545,0,0,1,6.56,27.1Zm2.683-4.483L6.91,28.578l-.241-.9a9.339,9.339,0,0,0-3.307-3.618l2.13,7.279H8.01l3.751-8.72Zm3.486,0L11.241,31.36H13.6L15.1,22.621Zm15.631,0H26.509a1.181,1.181,0,0,0-1.247.727l-3.519,8h2.5s.406-1.077.5-1.313h3.047c.071.3.288,1.3.288,1.3h2.211Zm-2.934,5.631c.2-.5.945-2.442.945-2.442s.2-.5.316-.831l.165.751.548,2.523ZM19.9,26.121c-.827-.4-1.337-.676-1.332-1.082s.43-.751,1.36-.751a4.289,4.289,0,0,1,1.781.335l.217.1.321-1.89a6.089,6.089,0,0,0-2.13-.364c-2.362,0-4.011,1.181-4.025,2.882,0,1.252,1.181,1.956,2.083,2.362s1.252.7,1.252,1.086c0,.586-.742.855-1.417.855a5,5,0,0,1-2.239-.472l-.307-.142L15.124,31a7.5,7.5,0,0,0,2.655.472c2.5,0,4.124-1.172,4.143-2.985C21.917,27.5,21.284,26.745,19.9,26.121Z",
    fill: "#273991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33621",
    "data-name": "Path 33621",
    d: "M5.762,23.31A.945.945,0,0,0,4.722,22.6H1.028L1,22.785a7.55,7.55,0,0,1,5.56,4.388Z",
    transform: "translate(0 -0.065)",
    fill: "#f99f1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.7c255b6ba713a589fda34e033b8b8d87.svg";
export { ForwardRef as ReactComponent };